import { gh, isExecute, vueDefineComponent } from '@syncfusion/ej2-vue-base';
import { isNullOrUndefined } from '@syncfusion/ej2-base';
export let IndicatorsDirective = vueDefineComponent({
    inject: { custom: { default: null } },
    render(createElement) {
        if (!isExecute) {
            let h = !isExecute ? gh : createElement;
            let slots = null;
            if (!isNullOrUndefined(this.$slots.default)) {
                slots = !isExecute ? this.$slots.default() : this.$slots.default;
            }
            return h('div', { class: 'e-directive' }, slots);
        }
        return;
    },
    updated() {
        if (!isExecute && this.custom) {
            this.custom();
        }
    },
    methods: {
        getTag() {
            return 'e-indicators';
        }
    }
});
export const IndicatorsPlugin = {
    name: 'e-indicators',
    install(Vue) {
        Vue.component(IndicatorsPlugin.name, IndicatorsDirective);
    }
};
export let IndicatorDirective = vueDefineComponent({
    render() {
        return;
    },
    methods: {
        getTag() {
            return 'e-indicator';
        }
    }
});
export const IndicatorPlugin = {
    name: 'e-indicator',
    install(Vue) {
        Vue.component(IndicatorPlugin.name, IndicatorDirective);
    }
};
